import { useMutation, useQueryClient } from "@tanstack/react-query";

import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";
import { cancelServiceRequest } from "../services/goHireService";

export const useCancelServiceRequest = (requestId: number, options?: { onSuccess?: () => void }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => cancelServiceRequest(requestId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.all });
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.serviceRequest(requestId) });
      options?.onSuccess?.();
    },
    onError: () => {},
  });
};
